/**
 * GeoFilterBar — Reusable country + region/state/province filter for all hubs
 */
import { COUNTRIES, getRegions } from "@/lib/geo-data";
import { MapPin, Globe } from "lucide-react";

export default function GeoFilterBar({ country, onCountryChange, region, onRegionChange, radius, onRadiusChange }) {
  const regions = getRegions(country);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-3">
      <div className="relative flex-1 min-w-[140px]">
        <Globe className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-app-secondary" />
        <select value={country || "all"} onChange={e => { onCountryChange(e.target.value); onRegionChange("all"); }}
          className="w-full bg-surface-input border border-input rounded-lg pl-8 pr-2 py-1.5 text-xs text-app appearance-none cursor-pointer focus:outline-none focus:border-violet-500">
          <option value="all">All Countries</option>
          {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
        </select>
      </div>
      {regions.length > 0 && (
        <div className="relative flex-1 min-w-[140px]">
          <MapPin className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-app-secondary" />
          <select value={region || "all"} onChange={e => onRegionChange(e.target.value)}
            className="w-full bg-surface-input border border-input rounded-lg pl-8 pr-2 py-1.5 text-xs text-app appearance-none cursor-pointer focus:outline-none focus:border-violet-500">
            <option value="all">{country === "all" ? "All Regions" : "All Regions/States"}</option>
            {regions.map(r => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      )}
      {radius !== undefined && (
        <div className="relative w-24">
          <input type="number" value={radius} onChange={e => onRadiusChange(e.target.value)}
            placeholder="km"
            className="w-full bg-surface-input border border-input rounded-lg px-2.5 py-1.5 text-xs text-app placeholder-text focus:outline-none focus:border-violet-500" />
        </div>
      )}
    </div>
  );
}
